import type { BakEvent, InvitationStatus } from '../types/event';

export type InvitationSummary = {
  total: number;
  accepted: number;
  declined: number;
  awaiting: number;
  committedFees: number;
};

export function summarizeInvitations(event: BakEvent): InvitationSummary {
  const accepted = event.invitations.filter((i) => i.status === 'Accepted');
  const declined = event.invitations.filter((i) => i.status === 'Declined').length;
  return {
    total: event.invitations.length,
    accepted: accepted.length,
    declined,
    awaiting: event.invitations.length - accepted.length - declined,
    committedFees: accepted.reduce((s, i) => s + i.proposedFee, 0),
  };
}

export function isAwaiting(status: InvitationStatus): boolean {
  return status !== 'Accepted' && status !== 'Declined';
}

export const invitationStatusStyle: Record<InvitationStatus, string> = {
  Sending: 'border-slate-200 bg-slate-50 text-slate-600',
  Delivered: 'border-sky-200 bg-sky-50 text-sky-700',
  Viewed: 'border-violet-200 bg-violet-50 text-violet-700',
  Accepted: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  Declined: 'border-red-200 bg-red-50 text-red-700',
};

export function daysUntil(iso: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((new Date(iso).getTime() - today.getTime()) / 86400000);
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}
